export const FormFieldset = {
  personInformation: 'personInformation',
  personAffiliation: 'personAffiliation',
  personContactData: 'personContactData',
  personadditionalinformation: 'personadditionalinformation',
  termsOfServiceAndPrivacyPolicy: 'termsOfServiceAndPrivacyPolicy',
} as const;
